import React from "react";

const Spinner = () => {
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-white">
      <div className="w-12 h-12 border-4 border-gray-300 border-t-[#BE202F] rounded-full animate-spin"></div>
    </div>
  );
};

export default Spinner;
